<template>
    <agile :nav-buttons="windowSize != 'mobile'" :infinite="true" :dots="true">
        <section class="hero is-large is-bold slide lb-home-image-slider">
            <div class="hero-body is-relative">
                <div class="is-overlay lb-slider-overlay"></div>
                <div class="container">
                    <div class="container has-text-centered">
                        <div class="columns is-centered">
                            <div class="column is-8">
                                <h1
                                    v-t="'Slides.slide_title_home'"
                                    class="title is-3 has-text-white"
                                ></h1>
                                <router-link
                                    v-if="isLoggedIn"
                                    v-t="'start'"
                                    :to="'creation'"
                                    class="lb-button has-background-pink-red has-text-white"
                                ></router-link>

                                <a
                                    v-else
                                    v-t="'start'"
                                    class="lb-button has-background-pink-red has-text-white"
                                    @click="login"
                                >
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section
            v-for="(slide, index) in slides"
            :key="index"
            :class="slide.classes"
            class="hero is-bold is-medium slide lb-home-image-slide"
        >
            <div class="hero-body">
                <div class="container">
                    <div class="columns is-mobile is-vcentered">
                        <div class="column is-offset-1">
                            <h1 class="subtitle is-5 has-text-weight-bold">
                                {{ $t(`Slides.${slide.caption}`) }}
                            </h1>
                            <h1
                                class="title has-text-weight-bold is-family-secondary is-2"
                            >
                                {{ $t(`Slides.${slide.title}`) }}
                            </h1>
                            <h1 class="subtitle">
                                {{ $t(`Slides.${slide.description}`) }}
                            </h1>
                        </div>
                        <div class="column is-hidden-mobile">
                            <figure class="image lb-slide-image">
                                <img
                                    :src="
                                        require(`@/assets/images/slider-home-${
                                            index + 1
                                        }.png`)
                                    "
                                    :srcset="sliderSrcset(index + 1)"
                                />
                            </figure>
                        </div>
                        <div class="column is-1"></div>
                    </div>
                </div>
            </div>
        </section>
        <template slot="prevButton">
            <span class="icon is-large">
                <i class="mdi mdi-48px mdi-chevron-left"></i>
            </span>
        </template>
        <template slot="nextButton">
            <span class="icon is-large">
                <i class="mdi mdi-48px mdi-chevron-right"></i>
            </span>
        </template>
    </agile>
</template>

<script>
import { VueAgile } from 'vue-agile';
export default {
    components: {
        agile: VueAgile,
    },

    data() {
        return {
            slides: [
                {
                    caption: 'slide_caption_1',
                    title: 'slide_title_1',
                    description: 'slide_description_1',
                    classes: 'is-marine-blue',
                },
                {
                    caption: 'slide_caption_2',
                    title: 'slide_title_2',
                    description: 'slide_description_2',
                    classes: 'is-red-purple',
                },
                {
                    caption: 'slide_caption_3',
                    title: 'slide_title_3',
                    description: 'slide_description_3',
                    classes: 'is-ugly-blue',
                },
            ],
        };
    },
    computed: {
        sliderSrcset() {
            return (slideIndex) => {
                `${require(`@/assets/images/slider-home-${slideIndex}@2x.png`)} 2x, ${require(`@/assets/images/slider-home-${slideIndex}@3x.png`)} 3x`;
            };
        },
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        windowSize() {
            return this.$mq;
        },
    },
    methods: {
        async login() {
            let loginURL = new URL(
                'https://accounts.google.com/o/oauth2/v2/auth'
            );
            let params = new URLSearchParams(loginURL.search.slice(1));
            params.append('access_type', 'offline');
            params.append('include_granted_scopes', true);
            params.append(
                'redirect_uri',
                process.env.VUE_APP_GOOGLE_REDIRECT_URI
            );
            params.append('client_id', process.env.VUE_APP_GOOGLE_CLIENT_ID);
            params.append('response_type', 'code');
            params.append('scope', 'email profile openid');
            params.append('prompt', 'consent');
            window.location = `${loginURL}?${params.toString()}`;
        },
    },
};
</script>

<style lang="sass" scoped>
@import "src/assets/sass/slider"
.slide
  display: block
  width: 100%
  max-height: 36rem
  height: 100%

.lb-home-image-slider
  background-image: url("~@/assets/images/home.jpeg")
  background-size: cover
  background-repeat: no-repeat
  background-position: center
  height: 100%
  .hero-body
    height: 100%

.lb-slider-overlay
  background-color: black
  opacity: 0.4
  height: 100%

.lb-slide-image
  max-width: 32rem
</style>
